import React from 'react'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { Helmet } from 'react-helmet'

import { getFundsList } from '../selectors/funds.js'
import { fetchingState } from '../helpers/hocs.js'
import { getTotal, getFunds } from '../store/reducers/funds/list.js'

import Link from './../components/Link'
import Button from './../components/Button'

const Funds = ({ items = [], total = 0, length = 0, fetching, loadMore, meta }) => (
  <div className='Founds'>
    <div className='Container Container_light'>
      <Link to='/connect'>
        <div className='Button Button_regButton'>
          <FormattedMessage id='funds.registration' />
        </div>
      </Link>
      <Helmet>
        <title>{meta.name}</title>
        <meta name='description' content={meta.description} />
        <meta property='og:title' content={meta.name} />
        <meta property='og:image' content={meta.image} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={meta.description} />
      </Helmet>
      {items.map((fund, i) => {
		//при наличие alias будет включен в ссылку на лот, если нет остается id
		let alias = fund._id
    let isMFC = fund._id == "5b30b97a7a86d3354a414b50"? true : false;
		if(fund.alias)
        {
          alias = fund.alias
        }
        return (
          fund.alias !== "konsorcium_zhenskih_nepravitelstvennyh_obedineniy" && fund.alias !== "mnogocelevoy_blagotvoritelnyy_fond_human"
            ? <Link key={i} className='Link Link_light Link_single Founds__Link' to={isMFC? '/aboutus' : '/funds/' + alias}>
                <span className='Head Founds__head'>{ fund.name }</span>
              {/*{ fund.sum  && !isMFC && <span className='Text Founds__total nobr'>*/}
              {/*  {numeral(fund.sum).format('0,0')}*/}
              {/*  {' '}*/}
              {/*  {fund.currency}*/}
              {/*  {' '}*/}
              {/*  <FormattedMessage id='funds.collected' />*/}
              {/*</span>}*/}
              </Link>
            : null
        )})}
      { ((total - items.length) > 0) && (<Button loading={fetching} onClick={loadMore}>
        <FormattedMessage id='funds.more' />
      </Button>)}
    </div>
  </div>
)

const mapStateToProps = state => ({
  ...getFundsList(state),
  currentLocale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({ getTotal, getFunds }, dispatch)
const mergeProps = (state, { getFunds, getTotal }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  getTotal,
  getFunds: (part, noLoader) => noLoader ? getFunds(part) : fetchingWrap(getFunds.bind(this, part))
})

// TODO: Добавить лоадер
export default compose(
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    loadMore: ({ length = 0, getFunds, fetching }) => async e => {
      e && e.preventDefault()
      if (fetching) return
      await getFunds(length)
    }
  }),
  lifecycle({
    componentDidMount () {
      this.props.getFunds(0, false)
      this.props.getTotal()
    }
  })
)(Funds)



// WEBPACK FOOTER //
// ./src/containers/Funds.jsx